<template>
  <div class="menu" :class="{ show: is_show }">
    <ul class="menu__list">
      <li v-for="item in menu_list" :key="item.icon">
        <div
          v-if="item.type === 'btn'"
          class="menu__list-item"
          @click="
            getCall({ type: 'sale', form: 'side-menu', title: item.form_title })
          "
        >
          <img
            :src="require('../images/icons/' + item.icon + '.svg')"
            :alt="item.icon"
            class="menu__list-icon"
          />
          <p class="menu__list-text">{{ item.text }}</p>
        </div>
        <a
          :href="item.link"
          v-if="item.type === 'link'"
          class="menu__list-item"
          target="_blank"
        >
          <img
            :src="require('../images/icons/' + item.icon + '.svg')"
            :alt="item.icon"
            class="menu__list-icon"
          />
          <p class="menu__list-text">{{ item.text }}</p>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Mixin from "../common/mixin";
import $ from "jquery";
import smoothScrollTo from "../common/smoothScrollTo";

export default {
  name: "side-menu",
  mixins: [Mixin],
  data() {
    return {
      menu_list: [
        {
          icon: "call",
          text: "Заказать звонок",
          type: "btn",
          form_title: "Заказать обратный звонок",
        },
        {
          icon: "price",
          text: "Оценка автомобиля",
          type: "btn",
          form_title: "Оценить автомобиль",
        },
        {
          icon: "calc",
          text: "Кредитный калькулятор",
          type: "btn",
          form_title: "Получить расчет по кредиту",
        },
        {
          icon: "testdrive",
          text: "Записаться на тест-драйв",
          type: "btn",
          form_title: "Записаться на тест-драйв",
        },
        {
          icon: "service",
          text: "Записаться на сервис",
          type: "btn",
          form_title: "Записаться на сервис",
        },
        {
          icon: "route",
          text: "Построить маршрут",
          type: "link",
          link: "https://yandex.ru/maps/213/moscow/?ll=37.507114%2C55.848354&mode=routes&rtext=~55.863904%2C37.463350&rtt=auto&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fll%3D37.463%252C55.864%26spn%3D0.001%252C0.001%26text%3D%25D0%25A0%25D0%25BE%25D1%2581%25D1%2581%25D0%25B8%25D1%258F%252C%2520%25D0%259C%25D0%25BE%25D1%2581%25D0%25BA%25D0%25B2%25D0%25B0%252C%2520%25D0%259B%25D0%25B5%25D0%25BD%25D0%25B8%25D0%25BD%25D0%25B3%25D1%2580%25D0%25B0%25D0%25B4%25D1%2581%25D0%25BA%25D0%25BE%25D0%25B5%2520%25D1%2588%25D0%25BE%25D1%2581%25D1%2581%25D0%25B5%252C%252063%25D0%2591&z=12.56",
        },
      ],
      is_show: false,
    };
  },
  mounted() {
    let contactsBlock = document.querySelector(".block-contacts");

    $(window).on("scroll", () => {
      let is_scrolled = window.scrollY > 200;

      if (
        is_scrolled &&
        window.scrollY < contactsBlock.offsetTop - contactsBlock.clientHeight
      ) {
        this.is_show = true;
      } else {
        this.is_show = false;
      }
    });
  },
  methods: {
    scrollTo(where) {
      let offset = this.device_platform === "desktop" ? 110 : 160;
      smoothScrollTo($("#" + where).offset().top - offset);
      window.location.href = "#" + where;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.menu {
  position: fixed;
  right: 0;
  top: 20%;
  z-index: 200;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

  &.show {
    transform: translateX(0);
  }

  &__list {
    list-style: none;
  }

  &__list-item {
    width: 80px;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: $gray_light;
    padding: 0 20px;
    border-bottom: 1px solid #e4e4e4;
    cursor: pointer;
    position: relative;

    &:last-child {
      border-bottom: none;
    }

    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: $gray;
      transform: translateX(100%);
      transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
      z-index: 1;
    }

    &:hover {
      &::after {
        transform: translateX(0);
      }
    }
  }

  &__list-icon {
    max-width: 25px;
    position: relative;
    z-index: 2;
  }

  &__list-text {
    text-align: center;
    margin-top: 5px;
    position: relative;
    z-index: 2;
    font-size: 10px;
  }
}

@media (max-width: 768px) {
  .menu {
    width: 100%;
    right: 0;
    bottom: 0;
    top: unset;

    &__list {
      display: flex;

      li {
        width: 20%;
      }
    }

    &__list-item {
      width: 100%;
      height: 56px;
      border-right: 1px solid #e4e4e4;
      border-left: 1px solid #e4e4e4;

      &::after {
        display: none;
      }
    }

    &__list-icon {
      max-width: 30px;
    }

    &__list-text {
      display: none;
    }
  }
}
</style>